<template>
  <div>
  </div>
</template>

<script>
  export default {
    name: 'desktop',
    data: function() {
      return {}
    },
    methods: {
    },
    mounted: function() {
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/desktop.vue